module.exports = __webpack_public_path__ + "51b0862a63c09a7ebc2d02386eb4838c.webp";